/* eslint-disable no-restricted-imports */
import { DirectProcessText } from '../../ui/business/ContentPromotion/types';

export const actionStatusMap = {
    [DirectProcessText.RESUME]: 'resume',
    [DirectProcessText.SUSPEND]: 'suspend',
    [DirectProcessText.START]: 'start',
};

export const notificationStatusMap = {
    [DirectProcessText.RESUME]: 'Кампания возобновлена',
    [DirectProcessText.SUSPEND]: 'Кампания приостановлена',
    [DirectProcessText.START]: 'Кампания запущена',
};
